import { Bleed, Box, Dialog } from 'braid-design-system';

import { LoginPrompt, type LoginPromptProps } from './LoginPrompt';

import { loginModalStyle } from './LoginPromptModal.css';
type Props = {
  open: boolean;
  onClose: () => void;
} & LoginPromptProps;

export const LoginPromptModal = ({
  open,
  onClose,
  ...loginPromptProps
}: Props) => (
  <Dialog
    id="login-prompt-modal"
    title=""
    description={undefined}
    width="medium"
    open={open}
    onClose={onClose}
  >
    <Box className={loginModalStyle}>
      <Bleed top="large">
        <LoginPrompt {...loginPromptProps} />
      </Bleed>
    </Box>
  </Dialog>
);
